import { Button, ModalButton, withCitrusTheme } from '@gousto-internal/citrus-react'

import type { Theme } from './theme'

// Confirm actions share one style: 12px/16px padding, 8px radius.
const confirmButtonStyle = (theme: Theme) => [
  {
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    borderRadius: '8px',
  },
  theme.responsiveFont([4, 4, 4, 4]),
]

export const CtaButton = withCitrusTheme(Button, confirmButtonStyle)

export const ModalConfirmButton = withCitrusTheme(ModalButton, confirmButtonStyle)
